import React, { useState } from 'react';
import CutomModal from './CutomModal';
import Button from 'react-bootstrap/Button';
import { Container } from 'react-bootstrap';

const Footer = () => {
    const [isTCVisible, setIsTCVisible] = useState(false);
    const [isPPVisible, setIsPPVisible] = useState(false);

    const handleTCClose = () => { 
        setIsTCVisible(false);
    }
    const handlePPClose = () => {
        setIsPPVisible(false);
    }
    return (
        <div className='py-5 text-center text-white' style={{ backgroundColor: "#0f1315" }}>
            <Container>
                <p>
                    Families of World War II Veterans is a non-profit, 501 (c) (3) charitable,
                    tax-exempt organization dedicated to honoring the heroic legacies of World War II
                    veterans and any persons involved in the WWII effort. We work to honor their legacies by
                    fostering educational opportunities through scholarship donations made possible by our
                    community members. The majority of the non-profit organization's volunteer work is
                    accomplished by committees and local chapters both throughout the U.S. and worldwide.
                </p>
                <a href="https://www.familiesww2veterans.org/" target="_blank" rel="noreferrer"
                    className='text-white'>Back to Families of WWII Veterans Website</a>
                <p><Button variant="link" onClick={() => setIsTCVisible(true)}
                    className="footerTCButton">Terms & Conditions</Button>
                </p>
                <p>Copyright © {new Date().getFullYear()}</p>
                <p>Families of World War II Veterans</p>
                <p>Families of World War II Veterans is a 501 (c)(3) tax-exempt, non-profit organization.</p>
            </Container>
            <CutomModal isModalVisible={isTCVisible} handleModalClose={handleTCClose}
                Compname="TermsAndConditions" modalTitle={"Families of WWIII Veterans Scholarship Terms & Conditions"} />
            <CutomModal isModalVisible={isPPVisible} handleModalClose={handlePPClose}
                Compname="PrivacyPolicy"
                modalTitle={"Families of WWII Veterans Privacy Policy"} />
        </div>
    );
}

export default Footer;